import { render, staticRenderFns } from "./ZimbraSharedMailService.vue?vue&type=template&id=1ef165fa&scoped=true&"
import script from "./ZimbraSharedMailService.vue?vue&type=script&lang=js&"
export * from "./ZimbraSharedMailService.vue?vue&type=script&lang=js&"
import style0 from "./ZimbraSharedMailService.vue?vue&type=style&index=0&id=1ef165fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef165fa",
  null
  
)

export default component.exports